export enum RideLimitPeriods {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month'
}
